"use client";
import { Bell, Download, User, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useTenantSummary } from "@/contexts/TenantSummaryContext";
import { isMsalConfigured } from "@/auth/msalConfig";
import { LogoutMenuItem } from "@/components/LogoutMenuItem";

const DashboardTopBar = () => {
  const { t } = useTranslation();
  const { summary, loading } = useTenantSummary();
  const tenantName = summary?.name ?? (loading ? "…" : "—");

  return (
    <header className="h-14 border-b border-border bg-background flex items-center justify-between px-6 sticky top-0 z-30">
      <div className="flex items-center gap-4">
        <span className="text-muted-foreground text-xs">{String(t("topbar.tenant"))}</span>
        <span className="text-sm font-medium">{tenantName}</span>
      </div>

      <div className="flex items-center gap-3">

        <Button size="sm" className="gap-1.5 text-xs">
          <Download className="h-3.5 w-3.5" />
          {String(t("topbar.dataExport"))}
        </Button>

        <button className="relative p-2 rounded-md hover:bg-secondary transition-colors">
          <Bell className="h-4 w-4 text-muted-foreground" />
          <span className="absolute top-1.5 right-1.5 h-1.5 w-1.5 rounded-full bg-destructive" />
        </button>

        <LanguageSwitcher />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 p-1.5 rounded-md hover:bg-secondary transition-colors">
              <div className="h-7 w-7 rounded-full bg-primary/10 flex items-center justify-center">
                <User className="h-3.5 w-3.5 text-primary" />
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            {isMsalConfigured ? (
            <LogoutMenuItem />
          ) : (
            <DropdownMenuItem
              className="gap-2 text-destructive"
              onClick={() => { window.location.href = "/api/auth/logout"; }}
            >
              <LogOut className="h-3.5 w-3.5" /> {String(t("topbar.logout"))}
            </DropdownMenuItem>
          )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default DashboardTopBar;
